import { FunctionComponent, useCallback, useState } from 'react'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserAPIProps } from '../types'
import ToiTeaserComponents from '@components/Teaser/Toi'
import SportsTile from './SportsTile'
import { LiveEventDataSportTypes } from '@utils/formatters/liveEvent'

interface TeaserSportsTilesProps {
  tiles: Required<TOITeaserAPIProps>['relatedMatches']
}

const { SportsTiles } = ToiTeaserComponents

const { TOITeaserSportsTilesContext } = contextToiTeaser

const TeaserSportsTiles: FunctionComponent<TeaserSportsTilesProps> = ({
  tiles,
}) => {
  const [tilesNumber, setTilesNumber] = useState(0)

  const addTile = useCallback(() => {
    setTilesNumber((currentTilesNumber) => currentTilesNumber + 1)
  }, [])

  const removeTile = useCallback(() => {
    setTilesNumber((currentTilesNumber) => currentTilesNumber - 1)
  }, [])

  return (
    <TOITeaserSportsTilesContext.Provider value={tilesNumber}>
      <SportsTiles>
        {tiles.map((tile) =>
          ![
            LiveEventDataSportTypes.SOCCER,
            LiveEventDataSportTypes.HOCKEY,
          ].includes(tile.typeOfSport) ? null : (
            <SportsTile
              key={`${tile.typeOfSport}-${tile.matchId}`}
              matchId={tile.matchId}
              typeOfSport={tile.typeOfSport}
              link={tile.link}
              onLoadSuccess={addTile}
              onUnmount={removeTile}
            />
          )
        )}
      </SportsTiles>
    </TOITeaserSportsTilesContext.Provider>
  )
}

export default TeaserSportsTiles
